import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import { AdminPreviewFragmentDoc } from '../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AdministratorsListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdministratorsListQuery = { __typename?: 'QueryRoot', administrators: Array<{ __typename?: 'Administrator', id: string, name: string }> };

export type CreateAdministratorMutationVariables = Types.Exact<{
  input: Types.CreateAdministratorInput;
}>;


export type CreateAdministratorMutation = { __typename?: 'MutationRoot', createAdministrator: { __typename?: 'CreateAdministratorPayload', password?: string | null, error?: string | null } };


export const AdministratorsListDocument = gql`
    query administratorsList {
  administrators {
    ...AdminPreview
  }
}
    ${AdminPreviewFragmentDoc}`;

export function useAdministratorsListQuery(options?: Omit<Urql.UseQueryArgs<AdministratorsListQueryVariables>, 'query'>) {
  return Urql.useQuery<AdministratorsListQuery, AdministratorsListQueryVariables>({ query: AdministratorsListDocument, ...options });
};
export const CreateAdministratorDocument = gql`
    mutation createAdministrator($input: CreateAdministratorInput!) {
  createAdministrator(input: $input) {
    password
    error
  }
}
    `;

export function useCreateAdministratorMutation() {
  return Urql.useMutation<CreateAdministratorMutation, CreateAdministratorMutationVariables>(CreateAdministratorDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAdministratorsListQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ administrators })
 *   )
 * })
 */
export const mockAdministratorsListQuery = (resolver: ResponseResolver<GraphQLRequest<AdministratorsListQueryVariables>, GraphQLContext<AdministratorsListQuery>, any>) =>
  graphql.query<AdministratorsListQuery, AdministratorsListQueryVariables>(
    'administratorsList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateAdministratorMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createAdministrator })
 *   )
 * })
 */
export const mockCreateAdministratorMutation = (resolver: ResponseResolver<GraphQLRequest<CreateAdministratorMutationVariables>, GraphQLContext<CreateAdministratorMutation>, any>) =>
  graphql.mutation<CreateAdministratorMutation, CreateAdministratorMutationVariables>(
    'createAdministrator',
    resolver
  )
